import React from 'react'
import PropTypes from 'prop-types'
import {Link as RouteLink, useLocation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {
    Text,
    Breadcrumb as ChakraBreadcrumb,
    BreadcrumbItem as ChakraBreadcrumbItem,
    BreadcrumbLink as ChakraBreadcrumbLink,
    useStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {categoryUrlBuilder} from '../../utils/url'

const Breadcrumb = ({categories, ...rest}) => {
    const intl = useIntl()
    const location = useLocation()
    const styles = useStyleConfig('Breadcrumb')

    const isPLPPage = location.pathname.includes('/collections')
    const isGCPage = location.pathname.includes('/giftcertpurchase')

    return (
        <ChakraBreadcrumb
            className="sf-breadcrumb"
            separator="/"
            {...styles.container}
            {...rest}
            sx={{
                '.chakra-breadcrumb__list': {
                    flexWrap: 'wrap'
                },
                '.chakra-breadcrumb__list-item a, .chakra-breadcrumb__list-item span:not([role="presentation"])':
                    {
                        textDecoration: 'underline',
                        textUnderlineOffset: '4px',
                        fontSize: 'md',
                        lineHeight: '6',
                        fontWeight: 'medium',
                        _hover: {
                            textDecoration: 'underline !important',
                            textUnderlineOffset: '4px'
                        }
                    },
                '.chakra-breadcrumb__list-item span[role="presentation"]': {
                    mx: '1',
                    fontSize: 'md',
                    lineHeight: '6'
                }
            }}
        >
            <ChakraBreadcrumbItem key="home" data-testid="sf-crumb-store">
                <ChakraBreadcrumbLink as={RouteLink} to="/">
                    Store
                </ChakraBreadcrumbLink>
            </ChakraBreadcrumbItem>

            {isGCPage && (
                <ChakraBreadcrumbItem key="gift-cards" data-testid="sf-crumb-gift-cards">
                    <ChakraBreadcrumbLink>GiftCards</ChakraBreadcrumbLink>
                </ChakraBreadcrumbItem>
            )}

            {categories?.map((category, index) => {
                const isLastCategory = index === categories.length - 1
                return (
                    <ChakraBreadcrumbItem key={category.id} data-testid="sf-crumb-item">
                        {isLastCategory && isPLPPage ? (
                            <Text as={'span'}>{category.name}</Text>
                        ) : (
                            <ChakraBreadcrumbLink
                                as={RouteLink}
                                to={categoryUrlBuilder(category, intl.locale)}
                            >
                                {category.name}
                            </ChakraBreadcrumbLink>
                        )}
                    </ChakraBreadcrumbItem>
                )
            })}
        </ChakraBreadcrumb>
    )
}

Breadcrumb.displayName = 'Breadcrumb'

Breadcrumb.propTypes = {
    categories: PropTypes.array
}

export default Breadcrumb
